import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { NgxHttpClient } from '@app/shared/ngx-http-client';
import { AuthService } from '@app/shared/services/auth.service';
import { FlexedService } from '@app/shared/services/flexed.service';

@Injectable()
export class UserSummaryService {
  constructor(
    private authService: AuthService,
    private http: NgxHttpClient,
    private flexedService: FlexedService
  ) {}

  public getMasteryPoints(doCache: boolean) {
    return this.http
      .get<string>('/user/GetMasteryPointsForUser', {
        cache: doCache,
      })
      .pipe(catchError(() => of('')));
  }

  public getFlexEd() {
    return this.flexedService
      .getCardDetails(
        this.authService.authUser.viewerProfile.userProfileKey,
        false
      )
      .pipe(catchError(() => of({})));
  }
}
